module.exports = __webpack_public_path__ + "static/media/beer_small.6d26df3c.jpg";